import { render, staticRenderFns } from "./UserNotes.vue?vue&type=template&id=800f8f46&scoped=true"
import script from "./UserNotes.vue?vue&type=script&lang=js"
export * from "./UserNotes.vue?vue&type=script&lang=js"
import style0 from "./UserNotes.vue?vue&type=style&index=0&id=800f8f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800f8f46",
  null
  
)

export default component.exports